/* eslint-disable no-param-reassign, arrow-body-style */
// @flow

import * as React from 'react'
import Glyphicon from 'react-bootstrap/lib/Glyphicon'
import { Mutation } from 'react-apollo'
import { CollectionView } from 'wijmo/wijmo'

import type { ColumnsMap, SaveStatus, UserViewState } from '../../types'
import type { CommonActionProps } from './types.actions'
import ButtonAction from './ButtonAction'
import { saveViewMutation } from '../../graphql/mutations/user'
import {
  filterColPropertiesToBeSaved,
  parseGroupPanels,
  parseSortDescriptions,
  getCollapsedGroupLevels,
} from '../../utils'
import { DesktopView, MobileView } from '../../config/mediaQuery'

type Props = {
  moduleName: string,
  columnsMapping: ColumnsMap,
  onViewSaved: (SaveStatus, UserViewState) => typeof undefined,
  saveStatus: SaveStatus,
  userViewState: UserViewState,
  frozenColumns: number,
  collection: CollectionView,
  filters?: any,
  grid?: any, // FlexGrid instance for getting collapsed state
}

class SaveViewAction extends React.PureComponent<CommonActionProps & Props> {
  static defaultProps = {
    size: 'xsmall',
  }

  render() {
    const columns =
      this.props.saveStatus === 'reset'
        ? []
        : filterColPropertiesToBeSaved(this.props.columnsMapping)

    // Capture collapsed group levels from the grid
    const collapsedGroups = this.props.grid 
      ? getCollapsedGroupLevels(this.props.grid)
      : [];

    return (
      <Mutation
        mutation={saveViewMutation}
        variables={{
          input: {
            columns,
            moduleName: this.props.moduleName,
            frozenColumns: this.props.frozenColumns,
            userViewState: this.props.userViewState,
            sorting:
              this.props.collection &&
              parseSortDescriptions(this.props.collection.sortDescriptions),
            groups:
              this.props.collection &&
              parseGroupPanels(this.props.collection.groupDescriptions),
            filterDefinition: this.props.filters,
            collapsedGroups,
          },
        }}
        onCompleted={data =>
          this.props.onViewSaved('saved', data.saveView.userViewState)
        }
        onError={() =>
          this.props.onViewSaved('error', this.props.userViewState)
        }
      >
        {(saveView, { loading }) => (
          <>
            <DesktopView>
              <ButtonAction
                onClick={saveView}
                bsSize={this.props.size}
                disabled={this.props.disabled || loading}
              >
                <Glyphicon glyph='save' /> {loading && 'Saving...'}
                {this.props.saveStatus === 'saved' && !loading && 'Saved!'}
                {this.props.saveStatus !== 'saved' && !loading && 'Save View'}
              </ButtonAction>
            </DesktopView>
            <MobileView>
              <button onClick={saveView} disabled={this.props.disabled || loading}>
                <img src='assets/save-bottom.svg' alt='save icon'/> {loading && 'Saving...'}
                {this.props.saveStatus === 'saved' && !loading && 'Saved!'}
                {this.props.saveStatus !== 'saved' && !loading && 'Save View'}
              </button>
            </MobileView>
          </>
        )}
      </Mutation>
    )
  }
}

export default SaveViewAction;
